import { ResourceOccupationStatusEnum } from './resource-occupation-status.enum';

export const getOccupationStatus = (url: string) => {
  const urlStatus = url.split('_').pop();
  const isCounter = url.includes('counter');

  if (isCounter) {
    return ResourceOccupationStatusEnum.Default;
  }

  switch (urlStatus) {
    case 'occupied.svg':
      return ResourceOccupationStatusEnum.Occupied;
    case 'unknown.svg':
      return ResourceOccupationStatusEnum.Unknown;
    case 'unoccupied.svg':
      return ResourceOccupationStatusEnum.Unoccupied;
    case 'closed.svg':
    case 'free.svg':
    case 'busy.svg':
      return ResourceOccupationStatusEnum.Default;
    default:
      console.warn('Occupation status could not be determined from url: ', url);
      return ResourceOccupationStatusEnum.Unknown;
  }
};
